import { useEffect, useState } from "react";
import { Button, Input, Form, Typography } from 'antd';
import Localize from '../../utils/string';
import history from "../../store/helpers/history";
import { forgot_password } from "../../store/emailAndPassword/emailAndPasswordAsyncActions";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { globalErrorResp } from "../../store/users/userActions";

const { Title } = Typography;

const ForgotPassword = () => {
    const loginResp = useSelector((state: any) => state.user.userSession);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [isShow, setIsShow] = useState<boolean>(false);
    const onSubmit = async (values: any) => {
        setLoading(true);
        const { email } = values;

        const params = { email }
        try {
            const response: any = await dispatch(forgot_password(params))
            if (response) {
                // history.push("/login");
                setIsShow(true);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setIsShow(false);
        }
    }

    useEffect(() => {
        scrollToTop();
    }, []);

    useEffect(() => {
        if (loginResp) {
            setLoading(true);
            history.push("/");
            setLoading(false);
        } 
    }, [loginResp]);

    const scrollToTop = () => {
        const top = document.getElementById("top") as HTMLElement;
        top.scrollIntoView();
    };

    return (
        <div className="login-page forgot-page" id="top">
            <div className="login-page-inner">
                <Title level={2}>{Localize.ForgotTitle}</Title>
                {isShow && <p className="forgot-password-message">
                    Password reset instructions have been sent to your registered email. Please check your inbox.
                </p>}
                <Form name="forgotPasswordForm" onFinish={onSubmit}>
                    <Form.Item
                        name="email"
                        rules={[
                            {
                                type: "email",
                                message: "Please enter a valid email",
                            },
                            { required: true, message: "Please Enter Email" },
                        ]}
                    >
                        <Input type="email" placeholder="Enter your email" />
                    </Form.Item>
                    <span className="forgot-password-wrapper">
                        Have an account? {' '}
                        <Link to="/login" className="forgot-password-title">
                            Login
                        </Link>
                    </span>

                    <Button loading={loading} className="rounded-btn" htmlType="submit" shape="circle">{Localize.ForgotButtonTitle}</Button>
                </Form>
            </div>
        </div >
    )
}

export default ForgotPassword;